export default {
  "instagram-downloader": {
    title: "Pengunduh Instagram — Unduh Video & Foto Instagram Gratis",
    h1: "Pengunduh Instagram",
    desc: "Unduh video, foto, reel, atau postingan carousel Instagram apa pun secara gratis. Tanpa login, tanpa watermark, berfungsi di iPhone, Android, dan PC.",
    metaDesc: "Pengunduh Instagram gratis — simpan video, foto, reels, dan postingan carousel Instagram dalam HD. Tanpa watermark, tanpa login. Berfungsi di iPhone, Android, dan PC.",
    keywords: "pengunduh instagram, unduh video instagram, pengunduh foto instagram, instagram downloader gratis",
    faq: [
      { q: "Bagaimana cara mengunduh video Instagram?", a: "Salin URL video Instagram, tempel di InstantSaver, klik Preview, lalu klik Download. Video Anda tersimpan dalam hitungan detik." },
      { q: "Bisakah saya mengunduh foto Instagram?", a: "Bisa. Tempel URL postingan dan InstantSaver akan mendeteksi apakah itu foto atau video lalu menampilkan tombol unduh yang sesuai." },
      { q: "Apakah saya perlu membuat akun?", a: "Tidak pernah perlu akun atau login. InstantSaver sepenuhnya gratis dan anonim." },
      { q: "Apakah ada watermark pada file yang diunduh?", a: "Tidak. File diunduh langsung dari CDN Instagram dalam kualitas aslinya — tanpa watermark ditambahkan." },
    ],
    featureTitle: "Apa yang Bisa Anda Unduh",
    features: [
      { icon: "🎬", text: "Instagram Reels — video full HD" },
      { icon: "🖼️", text: "Foto & postingan feed" },
      { icon: "🗂️", text: "Postingan carousel — setiap gambar satu per satu" },
      { icon: "📺", text: "Video panjang IGTV" },
      { icon: "👤", text: "Foto profil dalam kualitas asli" },
    ],
  },

  "reels-downloader": {
    title: "Pengunduh Instagram Reels — Simpan Reels dalam HD Gratis",
    h1: "Pengunduh Instagram Reels",
    desc: "Simpan Instagram Reel apa pun ke perangkat Anda dalam kualitas HD. Tanpa watermark, tanpa daftar, langsung berfungsi di perangkat apa pun.",
    metaDesc: "Unduh Instagram Reels dalam HD secara gratis. Tanpa watermark, tanpa login. Simpan reels ke iPhone, Android, atau PC dalam hitungan detik dengan InstantSaver.",
    keywords: "pengunduh instagram reels, unduh instagram reels, simpan reels, reels saver, unduh reels gratis",
    faq: [
      { q: "Bagaimana cara mengunduh Instagram Reels?", a: "Buka Reel di Instagram, ketuk menu titik tiga (⋯) dan salin tautannya. Tempel di InstantSaver dan klik Download." },
      { q: "Bisakah saya mengunduh Reels di iPhone?", a: "Bisa. InstantSaver berfungsi di Safari pada iPhone. Setelah diunduh, video ada di aplikasi Files atau Photos Anda." },
      { q: "Bisakah saya mengunduh Reels di Android?", a: "Bisa. Video otomatis tersimpan di folder Downloads perangkat Anda." },
      { q: "Apakah Reels yang diunduh berkualitas HD?", a: "Ya. Reels diambil dalam resolusi aslinya — hingga 1080p jika tersedia." },
    ],
    featureTitle: "Mengapa Menggunakan InstantSaver untuk Reels?",
    features: [
      { icon: "⚡", text: "Unduh Reel publik apa pun dalam waktu kurang dari 5 detik" },
      { icon: "🔇", text: "Tanpa watermark — file asli yang bersih" },
      { icon: "📱", text: "Berfungsi di iPhone, Android, tablet, dan desktop" },
      { icon: "🔒", text: "Tidak pernah perlu login atau akun" },
      { icon: "♾️", text: "Unduhan tanpa batas, tanpa batas harian" },
    ],
  },

  "youtube-downloader": {
    title: "Pengunduh Video YouTube — Unduh Video YouTube Gratis",
    h1: "Pengunduh Video YouTube",
    desc: "Unduh video YouTube dan Shorts secara gratis. Simpan video MP4 atau audio langsung ke perangkat Anda — cepat dan mudah.",
    metaDesc: "Pengunduh video YouTube gratis. Unduh video YouTube dan Shorts dalam format MP4 atau audio saja. Tidak perlu daftar. Cepat dan sederhana.",
    keywords: "pengunduh youtube, unduh video youtube, youtube video downloader, pengunduh youtube shorts, unduh youtube mp4",
    faq: [
      { q: "Bagaimana cara mengunduh video YouTube?", a: "Beralih ke tab YouTube di InstantSaver, tempel URL video, klik Preview, lalu klik Download." },
      { q: "Bisakah saya mengunduh YouTube Shorts?", a: "Bisa. Tempel URL Shorts dan InstantSaver akan menangani unduhan secara otomatis." },
      { q: "Kualitas apa yang diunduh?", a: "InstantSaver mengunduh kualitas pre-muxed terbaik yang tersedia, biasanya hingga 720p." },
      { q: "Bisakah saya hanya mengunduh audionya?", a: "Bisa. Setelah mempratinjau video, klik tombol Download Audio untuk mendapatkan trek audio M4A." },
    ],
    featureTitle: "Opsi Unduhan YouTube",
    features: [
      { icon: "🎥", text: "Video MP4 — opsi 360p, 480p, 720p" },
      { icon: "🎵", text: "Unduhan audio saja M4A" },
      { icon: "⚡", text: "YouTube Shorts — sama seperti video biasa" },
      { icon: "🔒", text: "Tidak perlu akun" },
      { icon: "📱", text: "Kompatibel dengan seluler dan desktop" },
    ],
  },

  "profile-picture-downloader": {
    title: "Pengunduh Foto Profil Instagram — Simpan Foto Profil HD",
    h1: "Pengunduh Foto Profil Instagram",
    desc: "Unduh foto profil Instagram siapa pun dalam ukuran penuh. Cukup tempel URL profil dan simpan DP secara instan.",
    metaDesc: "Unduh foto profil Instagram (DP) dalam kualitas asli. Tempel URL profil Instagram publik mana pun dan simpan foto ke perangkat Anda secara gratis.",
    keywords: "pengunduh foto profil instagram, instagram dp downloader, unduh foto profil instagram",
    faq: [
      { q: "Bagaimana cara mengunduh foto profil Instagram?", a: "Buka profil Instagram, salin URL-nya (mis. instagram.com/username), tempel di InstantSaver, lalu klik Download Profile Picture." },
      { q: "Bisakah saya mengunduh foto profil akun privat?", a: "Tidak. Hanya foto profil akun publik yang bisa diakses tanpa login." },
      { q: "Apakah foto yang diunduh versi ukuran penuh?", a: "InstantSaver mengunduh gambar berkualitas tertinggi yang tersedia dari CDN publik Instagram." },
      { q: "Format apa foto profil yang diunduh?", a: "Foto profil disimpan sebagai file JPEG." },
    ],
    featureTitle: "Cara Kerjanya",
    features: [
      { icon: "👤", text: "Berfungsi untuk akun Instagram publik mana pun" },
      { icon: "🖼️", text: "Mengunduh kualitas tertinggi yang tersedia" },
      { icon: "⚡", text: "Pratinjau instan sebelum mengunduh" },
      { icon: "🔒", text: "Tanpa login — anonim dan privat" },
      { icon: "📱", text: "Berfungsi di semua perangkat dan browser" },
    ],
  },

  "carousel-downloader": {
    title: "Pengunduh Carousel Instagram — Unduh Semua Foto & Video Carousel",
    h1: "Pengunduh Carousel Instagram",
    desc: "Unduh setiap foto dan video dari postingan carousel Instagram satu per satu atau sekaligus dengan satu klik.",
    metaDesc: "Unduh semua foto dan video dari postingan carousel Instagram. Simpan setiap item satu per satu atau gunakan Download All. Gratis, cepat, tanpa watermark.",
    keywords: "pengunduh carousel instagram, unduh carousel instagram, unduh banyak foto instagram, instagram album downloader",
    faq: [
      { q: "Bisakah saya mengunduh semua gambar carousel sekaligus?", a: "Bisa. Setelah menempel URL carousel, InstantSaver menampilkan setiap item dengan tombol unduh masing-masing plus tombol \"Download All\"." },
      { q: "Bagaimana jika carousel berisi campuran video dan foto?", a: "InstantSaver mendeteksi jenis setiap item secara otomatis — foto disimpan sebagai JPG, video sebagai MP4." },
      { q: "Apakah ada batas jumlah item yang bisa diunduh?", a: "Tidak ada batas. InstantSaver dapat mendeteksi dan mengunduh carousel hingga 20 item." },
      { q: "Bagaimana cara mendapatkan tautan carousel?", a: "Di Instagram, buka postingan, ketuk ⋯ dan pilih Copy Link. URL berisi /p/ — itu adalah postingan, yang bisa berupa carousel." },
    ],
    featureTitle: "Fitur Unduhan Carousel",
    features: [
      { icon: "🗂️", text: "Mendeteksi semua item carousel secara otomatis" },
      { icon: "⬇️", text: "Tombol unduh individual untuk setiap item" },
      { icon: "📦", text: "Tombol Download All untuk simpan massal sekali klik" },
      { icon: "🎬", text: "Menangani carousel foto + video campuran" },
      { icon: "✨", text: "Pratinjau thumbnail sebelum mengunduh" },
    ],
  },

  "stories-downloader": {
    title: "Pengunduh Story Instagram — Simpan Story Sebelum Hilang",
    h1: "Pengunduh Story Instagram",
    desc: "Simpan Story Instagram publik apa pun — foto atau video — ke perangkat Anda sebelum hilang dalam 24 jam. Tanpa login.",
    metaDesc: "Unduh Instagram Story secara gratis. Simpan foto dan video story publik sebelum kedaluwarsa. Tanpa login, tanpa watermark, berfungsi di perangkat apa pun.",
    keywords: "pengunduh instagram story, unduh instagram story, simpan instagram story, instagram story saver",
    faq: [
      { q: "Bagaimana cara mengunduh Instagram Story?", a: "Buka Story di Instagram, salin tautannya (atau tautan profil), tempel di InstantSaver, lalu klik Download." },
      { q: "Bisakah saya mengunduh Story secara anonim?", a: "Bisa. InstantSaver mengambil Story publik tanpa login, dan pemilik akun tidak akan diberi tahu." },
      { q: "Bisakah saya mengunduh Story dari akun privat?", a: "Tidak. Hanya Story dari akun publik yang bisa diakses tanpa login." },
      { q: "Apa yang terjadi setelah Story kedaluwarsa?", a: "Setelah Story hilang dari Instagram (setelah 24 jam, kecuali disimpan sebagai Highlight), InstantSaver tidak bisa lagi mengambilnya — unduh sebelum itu terjadi." },
    ],
    featureTitle: "Mengapa Menggunakan InstantSaver untuk Story",
    features: [
      { icon: "⏱️", text: "Simpan Story sebelum kedaluwarsa dalam 24 jam" },
      { icon: "🙈", text: "Anonim — pemilik akun tidak pernah diberi tahu" },
      { icon: "🎬", text: "Berfungsi untuk Story foto maupun video" },
      { icon: "🔒", text: "Tidak perlu login atau akun" },
      { icon: "📱", text: "Berfungsi di iPhone, Android, dan PC" },
    ],
  },

  "highlights-downloader": {
    title: "Pengunduh Highlights Instagram — Unduh Story Highlights Tersimpan",
    h1: "Pengunduh Highlights Instagram",
    desc: "Unduh video dan foto dari Story Highlights profil Instagram publik — story tersimpan yang disematkan di profil.",
    metaDesc: "Unduh Instagram Highlights secara gratis. Simpan foto dan video satu per satu dari Story Highlights profil publik yang disematkan.",
    keywords: "pengunduh instagram highlights, unduh instagram highlights, instagram highlight saver",
    faq: [
      { q: "Apa itu Instagram Highlights?", a: "Highlights adalah Story yang dipilih pengguna untuk disematkan secara permanen di profil mereka, dikelompokkan ke dalam koleksi bernama." },
      { q: "Bagaimana cara mengunduh Highlight?", a: "Buka Highlight di profil, salin tautannya, tempel di InstantSaver, lalu klik Download." },
      { q: "Bisakah saya mengunduh semua item dalam satu Highlight sekaligus?", a: "Bisa, selama Instagram mengizinkannya — InstantSaver menampilkan setiap slide dengan tombol unduh masing-masing." },
      { q: "Apakah saya perlu mengikuti akun untuk mengunduh Highlights mereka?", a: "Tidak, selama akunnya publik." },
    ],
    featureTitle: "Fitur Unduhan Highlights",
    features: [
      { icon: "📌", text: "Berfungsi untuk Highlights tersemat di profil publik mana pun" },
      { icon: "🎞️", text: "Mengunduh slide foto dan video satu per satu" },
      { icon: "🔒", text: "Tidak perlu login atau akun" },
      { icon: "📱", text: "Berfungsi di iPhone, Android, dan PC" },
    ],
  },
};
